import { render, staticRenderFns } from "./blog-post.vue?vue&type=template&id=48928c32&scoped=true&"
import script from "./blog-post.vue?vue&type=script&lang=js&"
export * from "./blog-post.vue?vue&type=script&lang=js&"
import style0 from "./blog-post.vue?vue&type=style&index=0&id=48928c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48928c32",
  null
  
)

export default component.exports